import ExitTicketsView from "@features/tools/view/exit-tickets-view";

const ExitTickets = () => {
  return <ExitTicketsView />;
};

export default ExitTickets;
